import { render, staticRenderFns } from "./OrderSchedule.vue?vue&type=template&id=521a18d0&"
import script from "./OrderSchedule.vue?vue&type=script&lang=js&"
export * from "./OrderSchedule.vue?vue&type=script&lang=js&"
import style0 from "./OrderSchedule.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports